// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1w1-K","tab":"Tabs_tab__2Y1jb","tabActive":"Tabs_tabActive__3cc04"};